import { createContext, ReactNode, useReducer } from "react"

export interface Plan {
  name: string
  billing_cycle: string
  type: string
  seats?: number
}

export interface State {
  plans: Plan[] | null
  selectedPlan: Plan | null
}

const initialState: State = {
  plans: null,
  selectedPlan: null,
}

type Action =
  | { type: "SET_PLANS"; payload: Plan[] | null }
  | { type: "SET_SELECTED_PLAN"; payload: Plan | null }

const reducer = (state: State, action: Action) => {
  switch (action.type) {
    case "SET_PLANS":
      return { ...state, plans: action.payload }
    case "SET_SELECTED_PLAN":
      return { ...state, selectedPlan: action.payload }
    default:
      return state
  }
}

export const SiteConfigContext = createContext<{
  state: State
  dispatch: React.Dispatch<Action>
}>({
  state: initialState,
  dispatch: () => undefined,
})

interface SiteConfigProviderProps {
  children: ReactNode
}

export function SiteConfigProvider({ children }: SiteConfigProviderProps) {
  const [state, dispatch] = useReducer(reducer, initialState)
  return (
    <SiteConfigContext.Provider value={{ state, dispatch }}>
      {children}
    </SiteConfigContext.Provider>
  )
}
